import { useLanguage } from "@/contexts/LanguageContext";
import { trpc } from "@/lib/trpc";
import { trackEvent } from "@/lib/site";
import { MessageCircle } from "lucide-react";
export function FloatingContact() {
  const {
    tx,
    tf,
    href: localeHref,
    dateLocale
  } = useLanguage();
  const {
    data
  } = trpc.public.bootstrap.useQuery();
  const contact = (data?.content?.["contact.details"] ?? {}) as {
    whatsapp?: string;
  };
  const number = contact.whatsapp?.replace(/\D/g, "");
  if (!number) return null;
  const message = encodeURIComponent("Hallo, ich interessiere mich für ein Setup in Nordzypern und möchte gerne mehr über die Möglichkeiten erfahren.");
  return <a href={`https://wa.me/${number}?text=${message}`} target="_blank" rel="noreferrer" onClick={() => trackEvent("whatsapp_clicked")} className="fixed bottom-4 right-4 z-40 flex items-center gap-2 bg-[#101010] px-4 py-3 text-xs font-bold text-white shadow-xl hover:bg-black"><MessageCircle className="h-4 w-4 text-[#C4A46B]" /><span className="hidden sm:inline">{tx("Persönlich schreiben")}</span></a>;
}
